<template>
  <div
    class="relative after:border-static-default-low after:absolute after:bottom-0 after:mb-8 after:w-full after:border-b"
  >
    <RevTabs
      class="mx-8"
      data-test="tradein-bo-nav"
      :label="i18n(translations.tabsLabel)"
      role="navigation"
      scrollable
      variant="flexible"
    >
      <RevTabItem
        v-if="shouldShow(ROUTE_NAMES.BUYBACK.WISHLIST, PERMISSION_TYPES.EDIT)"
        :active="route.name === ROUTE_NAMES.BUYBACK.WISHLIST"
        class="capitalize"
        :label="i18n(translations.buybackWishlist)"
        role="tab"
        :to="{ name: ROUTE_NAMES.BUYBACK.WISHLIST }"
      />
      <RevTabItem
        v-if="
          shouldShow(ROUTE_NAMES.BUYBACK.ORDERS.INDEX, PERMISSION_TYPES.EDIT)
        "
        :active="
          route.name?.toString().includes(ROUTE_NAMES.BUYBACK.ORDERS.INDEX)
        "
        class="capitalize"
        :label="i18n(translations.buybackOrders)"
        role="tab"
        :to="{ name: ROUTE_NAMES.BUYBACK.ORDERS.ACTIVE }"
      />
      <RevTabItem
        v-if="
          shouldShow(ROUTE_NAMES.BUYBACK.OPTIONS.INDEX, PERMISSION_TYPES.EDIT)
        "
        :active="
          route.name?.toString().includes(ROUTE_NAMES.BUYBACK.OPTIONS.INDEX)
        "
        class="capitalize"
        :label="i18n(translations.options)"
        role="tab"
        :to="{ name: ROUTE_NAMES.BUYBACK.OPTIONS.INDEX }"
      />
      <RevTabItem
        v-if="shouldShow(ROUTE_NAMES.SUPPORT)"
        class="capitalize"
        :data-qa="translations.support.id"
        :label="i18n(translations.support)"
        role="tab"
        :to="getExternalLinkList(BCP_47_LOCALES.fr_FR).SUPPORT_CENTER_LINK"
      />
    </RevTabs>
  </div>
</template>

<script setup lang="ts">
import { usePermissions, useRoute } from '#imports'

import { BCP_47_LOCALES } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTabItem } from '@ds/components/TabItem'
import { RevTabs } from '@ds/components/Tabs'

import { getExternalLinkList } from '~/constants/externalLinks'
import {
  PERMISSION_TYPES,
  type ScopePermissionType,
} from '~/constants/permissions'
import { ROUTE_NAMES } from '~/constants/routes'
import {
  type BusinessFeaturesKeys,
  type TemporaryBusinessFeaturesKeys,
  useBusinessFeaturesStore,
} from '~/scopes/config/stores/businessFeaturesStore'

import translations from './TabsBuyback.translations'

const route = useRoute()
const i18n = useI18n()
const { isFeatureEnabled } = useBusinessFeaturesStore()
const { hasRouteAccess } = usePermissions()

function shouldShow(
  routeName: string,
  permission?: ScopePermissionType,
  feature?: BusinessFeaturesKeys | TemporaryBusinessFeaturesKeys,
) {
  const shouldShowBasedOnAssociatedFeature =
    !feature || isFeatureEnabled(feature)

  const shouldShowBasedOnPermissions =
    !permission || hasRouteAccess({ name: routeName }, permission)

  return shouldShowBasedOnAssociatedFeature && shouldShowBasedOnPermissions
}
</script>
